import { render } from "./TourRunner.vue?vue&type=template&id=35bddf30"
import script from "./TourRunner.vue?vue&type=script&lang=js"
export * from "./TourRunner.vue?vue&type=script&lang=js"

import "./TourRunner.vue?vue&type=style&index=0&id=35bddf30&lang=css"

import exportComponent from "/prodflopclient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__